import { render, staticRenderFns } from "./PostFilesArea.vue?vue&type=template&id=02b15118&scoped=true&"
import script from "./PostFilesArea.vue?vue&type=script&lang=ts&"
export * from "./PostFilesArea.vue?vue&type=script&lang=ts&"
import style0 from "./PostFilesArea.vue?vue&type=style&index=0&id=02b15118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b15118",
  null
  
)

export default component.exports